import React from "react";
import WarningSvg from "../../../../Shared/Svgs/Warning";
import FlagSvg from "../../../../Shared/Svgs/Flag";

const Notification = ({
    type,
    title,
    dueDate,
    priority,
    category,
    message,
}) => {
    const isFlag = type === "flag";
    const badgeClass = isFlag
        ? priority.toLowerCase()
        : category.toLowerCase();

    return (
        <div className={`Notification ${type}`}>
            <div className="notificationDetails">
                <div
                    className={`notificationBadge ${badgeClass}`}
                >
                    {isFlag ? <FlagSvg /> : <WarningSvg />}
                    <span className="notificationType">
                        {isFlag ? priority : category}
                    </span>
                </div>
                <div className="notificationContent">
                    <span className="notificationTitle">
                        {isFlag ? title : message}
                    </span>
                    <span className="notificationDueDate">
                        {isFlag
                            ? `Due: ${dueDate}`
                            : dueDate}
                    </span>
                </div>
            </div>

            <div className="notificationDot"></div>
        </div>
    );
};

export default Notification;
